import React, { ReactNode, useState } from 'react'
import { BreadcrumbContext, BreadcrumbItem } from './BreadcrumbContext'

export const BreadcrumbProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([])

	return (
		<BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
			{children}
		</BreadcrumbContext.Provider>
	)
}
